<template>
  <div class="container">
    <modal v-on:cancel="handleDeleteModalResultCancel()" 
           v-on:ok="handleDeleteModalResultOK()" 
           v-if="showModal" v-bind:modalText="modalText" v-bind:showButtons="'OkCancel'" v-bind:deletingParticipantId="deletingParticipantId"></modal>    
    <header>
      <button class="button-icon square-icon w3-right" href="#" :title="$t('tournament.addGroup')" v-if="managementFunctions" @click="addGroup()"><font-awesome-icon icon="plus-square" class="align-icon" />  {{ $t('tournaments.group')}}</button>
      <button class="button-icon square-icon w3-right" href="#" :title="$t('tournament.addPlayer')" v-if="managementFunctions" @click="addRegistration()"><font-awesome-icon icon="plus-square" class="align-icon"/> {{ $t('tournament.player')}}</button>
    </header>

    <transition name="modal-fade" v-if="_showGroupEdit">
      <div class="modal-backdrop">
        <div class="modal">
          <section class="modal-body">
            <slot name="body">
              <add-group :groupId="selectedGroup" 
                         :action="_groupAction"
                         v-on:cancel="handleGroupModalResultCancel()" 
                         v-on:ok="handleGroupModalResultOK()" ></add-group>
            </slot>
          </section>
        </div>
      </div>
    </transition>

    <transition name="modal-fade" v-if="_showRegistrationEdit">
      <div class="modal-backdrop">
        <div class="modal">
          <section class="modal-body">
            <slot name="body">
              <add-registration :participant="selectedRegistration" 
                        :action="registrationAction"
                        v-on:cancel="handleRegistrationModalResultCancel()" 
                        v-on:ok="handleRegistrationModalResultOK()" ></add-registration>
            </slot>
          </section>
        </div>
      </div>
    </transition>

    <div v-if="errorMessage" class="w3-panel errorBox w3-round">
      {{ errorMessage }} 
      <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
    </div>

    <div class="groupSection" v-for="group in groups" :key="group.groupId">
      <a v-if="(groupRegistrations(group.groupId).length == 0) && managementFunctions" class="imgbtn" href="#" :title="$t('tournament.deleteGroup')" @click="deleteGroup(group.groupId)"><font-awesome-icon icon="trash" /></a>
      <span v-if="groups.length > 1"><font-awesome-icon icon="users" class=""/>{{group.name}} - </span> {{ $t('tournaments.registrations') }} ({{participantCount}})
      
      <table class="result-table" ><tbody>
      <tr class="result-header"><td>#</td><td>{{ $t('registration.name') }}</td><td class="right">{{ $t('registration.availability') }}</td><td class="right">{{ $t('person.rating') }}</td><td v-if="managementFunctions"></td><td v-if="managementFunctions"></td></tr>
      <tr class="result-row" v-for="(registration, regindex) in groupRegistrations(group.groupId)"
                              :key="registration.participantId"
                              :registration="registration">
          <td>{{ regindex + 1}}</td>
          <td class="result-cell-last"><router-link :to="'/persons/' + registration.person.personId">{{registration.person.name}}</router-link>
          <button class="grid-btn floatright" href="#" title="repair player availability per round" v-if="managementFunctions && uberUser" @click="repairParticipant(registration.participantId)"><font-awesome-icon icon="wrench" class="grid-icon"/></button>
          <button v-if="uberUser && registration.person.federationCode==0" href="#" class="grid-btn infoLinkReverse floatright"><font-awesome-icon icon="link" class="grid-icon"/></button>
          </td>
          <td class="right">
            <select v-model="registration.standardAvailability" :key="registration.participantId" v-on:change="setAvailability(registration)" v-if="managementFunctions" class="selectbox"> 
                <option :value="0"> {{ $t('registration.available') }} </option>
                <option :value="1"> {{ $t('registration.absent') }} </option>
              </select>
              <div class="center" v-if="!managementFunctions" v-html="availability(registration.standardAvailability)"> </div>          
          </td>
          <td class="right">{{registration.startingElo}}</td>
          <td class="result-cell-last" v-if="managementFunctions"><button class="grid-btn" href="#" :title="$t('registration.editPlayer')" v-if="managementFunctions && registration.person.federationCode == 0" @click="editParticipant(registration)"><font-awesome-icon icon="edit" class="grid-icon"/></button></td>
          <td class="result-cell-last" v-if="managementFunctions"><button class="grid-btn" href="#" :title="$t('registration.deletePlayer')" @click="preDeleteParticipant(registration.person.name, registration.participantId)"><font-awesome-icon icon="trash" class="grid-icon"/></button></td>
      </tr>
      <tr class="result-row" v-if="groupRegistrations(group.groupId).length == 0"><td colspan="4">{{ $t('tournaments.noplayers') }}</td></tr>
      </tbody></table>  
    </div>
  </div>
</template>


<script>
import {RestAPI} from "@aws-amplify/api-rest";
import {user} from "@/components/users";
import Modal from "@/components/Modal";
import AddGroup from "../groups/AddGroup.vue";
import AddRegistration from "../registrations/AddRegistration.vue";

const apiName = 'api';
const myInit = { 
  response: false,
};

export default {
  name: 'RegistrationsList',
  components: {AddGroup, AddRegistration, Modal},
  props: {
    tournamentId: String,
    managementFunctions: Boolean
  },
  data: function () {
    return {
      errorMessage: '',
      registrations: [],
      groups: [],
      showingModal: false,
      modalText: "",
      deletingParticipantId: "",
      selectedRegistration: {
        type: Object,
        required: false
      },
      showingGroupEdit: false,
      showingRegistrationEdit: false,
      groupAction: "edit",
      registrationAction: "edit"
    }
  },
  computed: {
    loggedIn() {
      return user.loggedIn;
    },
    participantCount() {
      return this.registrations.length;
    },
    _showGroupEdit: function() {
      return this.showingGroupEdit;      
    },
    _showRegistrationEdit: function() {
      return this.showingRegistrationEdit;      
    },
    showModal() {
      return this.showingModal;
    },
    sortedRegistrations() {
      return Array.from(this.registrations).sort((a, b) => {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })
    },
    _groupAction: function() {
      return this.groupAction;
    }
  },
  beforeMount() {
    this.loadGroups();
    this.loadParticipants();
  },
  methods: {
    addGroup: function() {
      this.selectedGroup = -1;
      this.groupAction = "add";
      this.showingGroupEdit = true;
    },

    addRegistration: function() {
      this.selectedRegistration = null;
      this.registrationAction = "add";
      this.showingRegistrationEdit = true;
    },

    availability: function(stdAvailability) {
      switch (stdAvailability) {
        case '0': 
          return 'available';
        case '1': 
          return 'absent';
        default: 
          return 'available';
      }
    },

    deleteGroup: function(groupId) {
      let path = '/group/' + groupId;
      let that = this;
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      console.log('Deleting group: ' + groupId);
      RestAPI
        .del(apiName, path, localInit)
        .then(response => {
          console.log('Succes.' + response);
          that.loadGroups();
          that.loadParticipants();
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    deleteParticipant: function() {
      let path = '/participant/' + this.deletingParticipantId;
      let that = this;
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      console.log('Deleting participant: ' + this.deletingParticipantId);
      RestAPI
        .del(apiName, path, localInit)
        .then(response => {
          console.log('Succes.' + response);
          that.loadParticipants();
        })
        .catch(error => {
          that.errorMessage = error.response.data.message;
          console.log(error.response.data.message);
        });
    },

    editGroup(groupId) {
      this.selectedGroup = groupId;
      this.groupAction = "edit";
      this.showingGroupEdit = true;
    },

    editParticipant(participant) {
      console.log("participant sent: " + JSON.stringify(participant));
      this.selectedRegistration = participant;
      this.registrationAction = "edit";
      this.showingRegistrationEdit = true;
    },

    groupRegistrations(groupId) {
      return this.registrations.filter(r => r.groupId == groupId);
    },

    handleGroupModalResultCancel() {
      console.log('Action cancelled');
      this.showingGroupEdit = false;
    },

    handleGroupModalResultOK() {
      console.log('Action ok-d');
      this.showingGroupEdit = false;
      this.loadGroups();
    },

    handleRegistrationModalResultCancel() {
      console.log('Action cancelled');
      this.showingRegistrationEdit = false;
    },

    handleRegistrationModalResultOK() {
      console.log('Action ok-d');
      this.showingRegistrationEdit = false;
      this.loadParticipants();
    },

    handleDeleteModalResultCancel() {
      console.log('Action cancelled');
      this.showingModal = false;
    },

    handleDeleteModalResultOK() {
      console.log('Action ok-d');
      this.showingModal = false;
      this.deleteParticipant();
    },

    loadGroups: function() {
      let path = '/tournament/' + this.tournamentId + '/group';
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          console.log("groups loaded")
          that.groups = response;
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadParticipants: function() {
      let path = '/tournament/' + this.tournamentId + '/participant';
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.registrations = response;
          console.log("Participant 1 " + JSON.stringify(that.registrations[0]));
        })
        .catch(error => {
          console.log(error.response);
        });
      console.log("Participants loaded for tournament " + that.tournamentId);
    },

    preDeleteParticipant(name, participantId) {
      this.modalText = 'Weet u zeker dat u speler "' + name + '" wilt verwijderen van de deelnemerslijst?';
      this.deletingParticipantId = participantId;
      console.log('About to delete: '+ participantId);
      this.showingModal=true;
    },

    repairParticipant(participantId) {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false
      };
      let path = '/participant/' + participantId + '/reparo';
      RestAPI
        .post(apiName, path, myInit)
        .catch(error => {
          console.log(error.response);
        });
      console.log("Participant repaired");
    },

    setAvailability: function(participant) {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: participant,
        response: false
      };
      let completePath = '/participant/' + participant.participantId;
      console.log("participant: " + participant);
      RestAPI
        .put(apiName, completePath, myInit)
        .then(response => {
          console.log ("participant updated: " + response);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },
    
    uberUser: function() {
      var uber = false;
      if (this.$CAUser != null) {
        if (this.$CAUser.getChessUser() != null) {
          uber = (process.env.VUE_APP_UBER == this.$CAUser.getChessUser().login);
        }
      }
      return uber; 
    }
    
  }
}
</script>

<style scoped>
.groupItem {
  font-weight: bold;
}

.groupSection {
  margin-top: 2vw;
}

.imgbtn {
  float: right;
  border: 1px solid #333333;
  border-radius: 2px;
}

.selectbox {
  border: 1px solid #333333;
  border-radius: 2px;
  color: inherit;
  background-color: #333333;  
  padding-left: 8px;
  padding-right: 8px;
}

.selectbox:hover {
  border: 1px solid #365c96;
  transition: border .3s linear;
  border-radius: 2px;
  color: inherit;
  background-color: #333333;  
  padding-left: 8px;
  padding-right: 8px;
}

.right {
  width: auto;
  text-align: right;
}

/* mobile */
@media screen and (max-width: 600px) {
  .details {
    padding: 0vw 2vw;
  }
  .modal {
    width: 98vw;
    max-height: 90vh;
    overflow-x: hidden;
    overflow-y: hidden;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .details {
    padding: 0vw 2vw;
  }
  .modal {
    width: 50vw;
    max-height: 90vh;
    overflow-x: hidden;
    overflow-y: hidden;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .details {
    padding: 0vw 2vw;
  }
  .modal {
    width: 46vw;
    max-height: 90vh;
    overflow-x: hidden;
    overflow-y: hidden;
  }
}

</style>

